import { BASICS } from "./basics";
import { BONUS_MOVES } from "./bonusMoves";
import { HOUSE_RULES } from "./houseRules";
import type { Tutorial } from "./script";
import { WILD_CARDS } from "./wildCards";

/**
 * Every tutorial, in the order How to Play lists them and each one's closing
 * card offers the next. Ordered by what a new player meets first in a default
 * game, where every wild and house rule is on.
 */
export const TUTORIALS: readonly Tutorial[] = [BASICS, BONUS_MOVES, WILD_CARDS, HOUSE_RULES];

/** The tutorial a route names, falling back to Basics for `/tutorial` (the first-launch redirect) or an unknown id. */
export function tutorialById(id: string | undefined): Tutorial {
  return TUTORIALS.find((t) => t.id === id) ?? BASICS;
}

/** The one after this in the list, or null for the last. */
export function nextTutorial(id: string): Tutorial | null {
  const i = TUTORIALS.findIndex((t) => t.id === id);
  return i >= 0 && i < TUTORIALS.length - 1 ? TUTORIALS[i + 1] : null;
}
